import React, {useState, Suspense} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image as AtomicImage } from '@thd-olt-component-react/image';
import { getVideoId } from '../../helpers/helpers';
import VideoPlayer from '../VideoPlayer/VideoPlayer.component';
import './Image.scss';

/**
 * @group Layout
 * Displays Etch Image component
 */

const Image = (props) => {
  const { opts = {}, channel } = props;
  
  const {
    id,
    link = '',
    mediaData = {},
    mediaMobileData = {},
    isStretchy,
    name
  } = opts;
  const isMobile = channel === 'mobile';
  const media = isMobile ? mediaMobileData : mediaData;
  const { src, alt, height, width } = media;
  const imgClass = classNames({
    'img--block':height && width,
    'stretchy': isStretchy
  });

  const videoId = getVideoId(link);

  return (
    <div className="content_image" id={id}>
      {link
        && (
          videoId ?
          <VideoPlayer
            videoId={videoId}
            channel={channel}
            videoStill={src}
            className={imgClass}
          />
          :
          <a href={link}>
            <AtomicImage
              stretchy
              src={src}
              className={imgClass}
              alt={alt}
              title={name}
              lazy
              height={height}
              width={width}
            />
          </a>
        )}
      {!link
        && <AtomicImage
          stretchy
          src={src}
          className={imgClass}
          alt={alt}
          title={name}
          lazy
          height={height}
          width={width}
        />
      }
    </div>
  );
};

Image.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isStretchy: PropTypes.bool,
    mediaData: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    name: PropTypes.string
  }).isRequired,
  channel: PropTypes.oneOf([
    'desktop',
    'mobile'
  ]),
};

Image.defaultProps = {
  channel: 'desktop'
};

export default Image;
